import React from "react";
import ReactExport from "react-export-excel";
import * as Records from '../store/Records';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


export default class ExportExcel extends React.Component {

    constructor(props) {
        super(props);

		const priceHolter = this.props.study.priceHolter;
		const price12lead = this.props.study.price12lead;
		const priceEventSymptomatic = this.props.study.priceEvent;
		const priceEventScheduled = this.props.study.priceEvent;

        this.state = {
			buttonElement: this.props.buttonElement,
			isBillable: props.isBillable,
			billableItems: props.billableItems,
			records: props.records,
			reportMonth: props.reportMonth,
			priceHolter: priceHolter,
			price12lead: price12lead,
			priceEventSymptomatic: priceEventSymptomatic,
			priceEventScheduled: priceEventScheduled,
		}
	}

	aggregateData() {
		const theState = this.state;

		// console.log(`aggregateData() `);

		let dataToExport = {
			columns: [
					"Quantity",
					"Item Code",
					"Description",
					"U/M",
					"Price Each",
					"Amount",
			],
			data: []
		};

		if ( ! theState.billableItems || ! theState.isBillable ) {
			return [];
		}

		dataToExport = {...dataToExport, data: 
			theState.billableItems.map( bi => [ bi.qty, bi.code, bi.description, bi.isUorM, bi.price, bi.amount ] )
		};

		const recs = theState.records.filter( rec => theState.isBillable[rec.id] === true );

		let recsHolter = recs.filter( rec => rec.serviceType === Records.recordServiceTypes.holter);
		let recs12lead = recs.filter( rec => rec.serviceType === Records.recordServiceTypes.twelveLead);
		let recsEventScheduled = recs.filter( rec => (rec.serviceType === Records.recordServiceTypes.event) && (rec.isMdOverreadComplete === true) );
		let recsEventSymptomatic = recs.filter( rec => (rec.serviceType === Records.recordServiceTypes.event) && (rec.isMdOverreadComplete !== true) );

		dataToExport.data.push( [ recs12lead.length, "Billable Work", "12lds ECG", "ea", theState.price12lead, recs12lead.length * theState.price12lead ] );
		dataToExport.data.push( [ recsEventScheduled.length, "Billable Work", "Scheduled Events", "ea", theState.priceEventScheduled, recsEventScheduled.length * theState.priceEventScheduled ] );
		dataToExport.data.push( [ recsEventSymptomatic.length, "Billable Work", "Symptomatic Events", "ea", theState.priceEventSymptomatic, recsEventSymptomatic.length * theState.priceEventSymptomatic ] );
		dataToExport.data.push( [ recsHolter.length, "Billable Work", "24 hours Holter", "ea", theState.priceHolter, recsHolter.length * theState.priceHolter ] );

		// console.dir(dataToExport);

		return [dataToExport];
	}

    render() {

		const filename = "ProjectBillingWorksheet_" + this.state.reportMonth.replace(" ","_");

		return (
            <ExcelFile hideElement={this.props.hideElement} filename={filename} element={this.state.buttonElement} >
                <ExcelSheet dataSet={this.aggregateData()} name="Organization"/>
            </ExcelFile>
			);
    }
}




// WEBPACK FOOTER //
// ./src/components/ExportExcel.js